export default "__VITE_ASSET__COoWIVM2__"